// src/components/Contact.js
import React from 'react';
import { Box, Container, Grid, Typography, Button, Paper } from '@mui/material';

const Contact = () => {
  const subject = "info";
  const email = "lopezj@demand-creator.eu";          // Dirección de correo para contacto
  const phone = "+34 669 844 971";                     // Número de teléfono
  const wechatPhone = "+34 669 844 971";               // Número de teléfono para WeChat (ajústalo según necesites)

  return (
    <Box
      sx={{
        width: '100%',
        py: { xs: 3, md: 4 },
        px: { xs: 2, md: 4 },
        textAlign: 'center'
      }}
    >
      {/* Título de la sección */}
      <Typography 
        variant="h3" 
        align="center" 
        gutterBottom 
        sx={{
          fontWeight: 'bold',
          color: 'rgb(3,116,206)',
          fontSize: { xs: '2rem', md: '3rem' }
        }}
      >
        Contact Us
      </Typography>
      {/* Texto descriptivo */}
      <Typography variant="h6" sx={{ mb: 3 }}>
        If you want to obtain more information, please feel free to contact us using the options below:
      </Typography>

      {/* Contenedor de los 3 cuadrados */}
      <Container maxWidth="md">
        <Grid container spacing={4}>
          {/* Cuadrado de Email */}
          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                textAlign: 'center',
                backgroundColor: 'rgba(139,206,252, 0.45)',
                borderRadius: 2
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/27.png`}
                alt="Email Icon"
                style={{ width: '3rem', height: '3rem', marginBottom: '1rem' }}
              />
              <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                Email
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {email}
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: 'rgb(3,116,206)', color: 'white' }}
                href={`mailto:${email}?subject=${encodeURIComponent(subject)}`}
              >
                Write Us
              </Button>
            </Paper>
          </Grid>

          {/* Cuadrado de Teléfono */}
          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                textAlign: 'center',
                backgroundColor: 'rgba(139,206,252, 0.45)',
                borderRadius: 2
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/26.png`}
                alt="Phone Icon"
                style={{ width: '3rem', height: '3rem', marginBottom: '1rem' }}
              />
              <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                Phone
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {phone}
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: 'rgb(3,116,206)', color: 'white' }}
                href={`tel:${phone}`}
              >
                Call Us
              </Button>
            </Paper>
          </Grid>

          {/* Cuadrado de WeChat */}
          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                textAlign: 'center',
                backgroundColor: 'rgba(139,206,252, 0.45)',
                borderRadius: 2
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/28.png`}
                alt="WeChat Icon"
                style={{ width: '3rem', height: '3rem', marginBottom: '1rem' }}
              />
              <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                WeChat
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {wechatPhone}
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: 'rgb(3,116,206)', color: 'white' }}
                href={`weixin://dl/chat?username=${encodeURIComponent(wechatPhone)}`}
              >
                Connect via WeChat
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact;
